import PropTypes from 'prop-types';
import { getMonthName } from '../../../utils/date';
import ClimateWeatherNugget from './climateWeatherNugget';
import './climateWeatherNuggetDashboard.scss';
import HorizontalScroll from './horizontalScroll';

const CLIMATE_WEATHER_CARD_WIDTH = 165;
const STEP_SIZE = CLIMATE_WEATHER_CARD_WIDTH * 2;

const ClimateWeatherNuggetDashboard = (props) => {
  const { climate, siteId, currentMonth, onClick } = props;

  if (!climate.temperature) {
    climate.temperature = {};
  }
  if (!climate.temperature.day) {
    climate.temperature.day = [];
  }
  if (!climate.temperature.night) {
    climate.temperature.night = [];
  }

  return (
    <HorizontalScroll
      stepSize={STEP_SIZE}
      initialScroll={currentMonth * CLIMATE_WEATHER_CARD_WIDTH}
    >
      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((i) => {
        return (
          <div key={i} className="gw-weather-dashboard-item">
            <ClimateWeatherNugget
              key={i}
              month={getMonthName(i, siteId)}
              day={climate.temperature.day[i]}
              night={climate.temperature.night[i]}
              active={currentMonth === i}
              onClick={onClick}
            />
          </div>
        );
      })}
    </HorizontalScroll>
  );
};

ClimateWeatherNuggetDashboard.propTypes = {
  climate: PropTypes.shape({
    temperature: PropTypes.shape({
      day: PropTypes.arrayOf(PropTypes.number),
      night: PropTypes.arrayOf(PropTypes.number),
    }),
  }),
  siteId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currentMonth: PropTypes.number,
  onClick: PropTypes.func.isRequired,
};

ClimateWeatherNuggetDashboard.defaultProps = {
  siteId: 1,
  currentMonth: 0,
  climate: {},
};

export default ClimateWeatherNuggetDashboard;
